import { routes as routerRoutes } from '@/router/router';
import store from '@/store/store';
import { i18n } from '@/i18n/i18n';
import globalData from '@/store/globalData';

let wasTipboxActivated = null;
function isTipboxActive() {
    if (wasTipboxActivated === true) {
        return true; // Once activated, always return true
    }
    const tipbox = store.getters['tipbox/getTipboxSettings'];
    const isActive = tipbox && tipbox.policies && tipbox.paymentDataCompleted;
    if (isActive) {
        wasTipboxActivated = true;
    }
    return isActive;
}

/* eslint-disable prettier-vue/prettier, semi */
const dashboard = {
    icon: 'home',
    img: 'dashboard.svg',
    get label() { return i18n.t('sidebar.dashboard') },
    to: { name: 'Dashboard' },
};
const widget = {
    icon: 'box',
    img: 'widget-bb.svg',
    get label() { return i18n.t('sidebar.widgetBuyBox') },
    to: { name: 'Widget' },
};
const widgetSettings = {
    get label() { return i18n.t('sidebar.widgetSettings') },
    to: { name: 'WidgetSettings' },
};
const widgetGenerator = {
    get label() { return i18n.t('sidebar.generator') },
    to: { name: 'WidgetGenerator' },
};
const textLinks = {
    icon: 'external-link',
    img: 'affiliate-links.svg',
    get label() { return i18n.t('sidebar.affiliateLinks') },
    to: { name: 'TextLinks' },
};
const productLandingPage = {
    icon: 'monitor',
    img: 'gdziekupicto.svg',
    get label() { return i18n.t('sidebar.gdziekupicTo') },
    to: { name: 'ProductLandingPage' },
};
const productLandingPageSettings = {
    get label() { return i18n.t('sidebar.productLandingPageSettings') },
    to: { name: 'ProductLandingPageSettings' },
};
const productLandingPageGenerator = {
    get label() { return i18n.t('sidebar.productLandingPageGenerator') },
    to: { name: 'ProductLandingPageGenerator' },
};
const reports = {
    icon: 'activity',
    img: 'reports.svg',
    get label() { return i18n.t('sidebar.reports') },
    to: { name: 'Reports' },
};
const reportsStats = {
    get label() { return i18n.t('sidebar.stats') },
    to: { name: 'ReportsStats' },
};
const reportsTransactions = {
    get label() { return i18n.t('sidebar.transactions') },
    to: { name: 'ReportsTransactions' },
};
const reportsPages = {
    get label() { return i18n.t('sidebar.reportsPages') },
    to: { name: 'ReportsPages' },
};
const reportPages = {
    get label() { return i18n.t('sidebar.reportPages') },
    to: { name: 'ReportsPages' },
};
const reportShops = {
    get label() { return i18n.t('sidebar.reportPrograms') },
    to: { name: 'ReportsShops' },
};
const reportProducts = {
    get label() { return i18n.t('sidebar.reportProducts') },
    to: { name: 'ReportsProducts' },
};
const reportsConversion = {
    get label() { return i18n.t('sidebar.reportsConversion') },
    to: { name: 'ReportsConversion' },
};
const reportsIntegrationStatus = {
    get label() { return i18n.t('sidebar.reportsIntegrationStatus') },
    to: { name: 'ReportsIntegrationStatus' },
};
const reportsFeedImportSummary = {
    get label() { return i18n.t('sidebar.feedImportSummary') },
    to: { name: 'ReportsFeedImportSummary' },
};
const reportsWidgetVersionChart = {
    get label() { return i18n.t('sidebar.reportsWidgetVersionChart') },
    to: { name: 'ReportsWidgetVersionChart' },
};
const settings = {
    icon: 'settings',
    img: 'settings.svg',
    get label() { return i18n.t('sidebar.settings') },
    to: { name: 'Settings' },
};
const pages = {
    icon: 'layout',
    img: 'your-pages.svg',
    get label() { return i18n.t('sidebar.pages') },
    to: { name: 'Pages' },
};
const shops = {
    icon: 'shopping-cart',
    img: 'affiliate-programs.svg',
    get label() { return i18n.t('sidebar.affiliatePrograms') },
    to: { name: 'Shops' },
};
const finance = {
    icon: 'trending-up',
    img: 'finances.svg',
    get label() { return i18n.t('sidebar.finance') },
    to: { name: 'Finance' },
};
const settingsApi = {
    get label() { return i18n.t('sidebar.api') },
    to: { name: 'SettingsApi' },
};
const settingsIntegrations = {
    get label() { return i18n.t('sidebar.integrations') },
    to: { name: 'SettingsIntegrations' },
};
const webpagesPublishers = {
    icon: 'file-text',
    get label() { return i18n.t('sidebar.webpagesPublishers') },
    to: { name: 'Webpages' },
};
const webpagesAdmin = {
    icon: 'file-text',
    get label() { return i18n.t('sidebar.webpagesAdmin') },
    to: { name: 'Webpages' },
};
const webpagesListAdmin = {
    icon: 'file-text',
    get label() { return i18n.t('pagesList') },
    to: { name: 'WebpagesList' },
};
const settingsShopPresentation = {
    get label() { return i18n.t('sidebar.shopPresentation') },
    to: { name: 'SettingsShopPresentation' },
};
const api = {
    icon: 'layers',
    get label() { return i18n.t('sidebar.api') },
    to: { name: 'Api' },
};
const offersCatalog = {
    icon: 'folder',
    get label() { return i18n.t('sidebar.offersCatalog') },
    to: { name: 'OffersCatalog' },
};
const catalog = {
    icon: 'folder',
    get label() { return i18n.t('sidebar.catalog') },
    to: { name: 'Catalog' },
};
const catalogProducts = {
    get label() { return i18n.t('sidebar.catalogProducts') },
    to: { name: 'CatalogProducts' },
};
const catalogManufacturers = {
    get label() { return i18n.t('sidebar.catalogManufacturers') },
    to: { name: 'CatalogManufacturers' },
};
const catalogBrands = {
    get label() { return i18n.t('sidebar.catalogBrands') },
    to: { name: 'CatalogBrands' },
};
const catalogCategories = {
    get label() { return i18n.t('sidebar.catalogCategories') },
    to: { name: 'CatalogCategories' },
};
const catalogProductVariants = {
    get label() { return i18n.t('sidebar.productVariants') },
    to: { name: 'CatalogProductVariants' },
};
const users = {
    icon: 'users',
    get label() { return i18n.t('sidebar.users') },
    to: { name: 'Users' },
};
const offers = {
    icon: 'search',
    get label() { return i18n.t('sidebar.offers') },
    to: { name: 'Offers' },
};
const settlements = {
    icon: 'dollar-sign',
    get label() { return i18n.t('sidebar.settlements') },
    to: { name: 'Settlements' },
};
const settlementsReport = {
    icon: 'dollar-sign',
    get label() { return i18n.t('sidebar.advertiserSettlements') },
    to: { name: 'SettlementsReport' },
};
const settlementsInvoices = {
    icon: 'dollar-sign',
    get label() { return i18n.t('sidebar.advertiserSettlementsList') },
    to: { name: 'SettlementsInvoices' },
};
const campaignsAdmin = {
    icon: 'shopping-cart',
    get label() { return i18n.t('sidebar.campaigns') },
    to: { name: 'Campaigns' },
};
const campaignsListAdmin = {
    icon: 'list',
    get label() { return i18n.t('list') },
    to: { name: 'CampaignsList' },
};
const producerProducts = {
    icon: 'box',
    get label() { return i18n.t('sidebar.producerProducts') },
    to: { name: 'ProducerProducts' },
};
const producerProductsSearch = {
    get label() { return i18n.t('sidebar.producerProductsSearch') },
    to: { name: 'ProducerProductsProducts' },
};
const producerProductsImport = {
    get label() { return i18n.t('sidebar.producerProductsImport') },
    to: { name: 'ProducerProductsImport' },
};
const products = {
    icon: 'search',
    get label() { return i18n.t('sidebar.aggregateSearch') },
    to: { name: 'Products' },
};
const transactions = {
    icon: 'list',
    get label() { return i18n.t('sidebar.transactions2') },
    to: { name: 'Transactions' },
};
const transactionImport = {
    get label() { return i18n.t('sidebar.transactionsImport') },
    to: { name: 'TransactionsImport' },
};
const transactionValidation = {
    get label() { return i18n.t('sidebar.transactionValidation') },
    to: { name: 'TransactionsValidation' },
};
const transactionCorrection = {
    get label() { return i18n.t('sidebar.transactionCorrection') },
    to: { name: 'TransactionsCorrection' },
};
const financeSubscriptions = {
    get label() { return i18n.t('sidebar.subscriptions') },
    to: { name: 'FinanceSubscriptions' },
};
const adminFinanceSettlementsPublishers = {
    get label() { return i18n.t('sidebar.settlementsWithPublishers') },
    to: { name: 'AdminFinanceSettlementsPublishers' },
};
const adminTipbox = {
    icon: 'dollar-sign',
    get label() { return i18n.t('sidebar.tipbox') },
    to: { name: 'Tipbox' },
};
const adminTipboxTips = {
    get label() { return i18n.t('sidebar.tips') },
    to: { name: 'TipboxTips' },
};
const adminTipboxVerification = {
    get label() { return i18n.t('sidebar.verification') },
    to: { name: 'AdminTipboxVerification' },
};
const adminTipboxSettlements = {
    get label() { return i18n.t('sidebar.settlements') },
    to: { name: 'TipboxSettlements' },
};
// const widgeterTipbox = {
//     icon: 'dollar-sign',
//     img: 'tipbox.svg',
//     get label() { return i18n.t('sidebar.tipbox') },
//     to: { name: 'Tipbox' },
//     get isActive() { return isTipboxActive() },
// };
const activateWidgeterTipbox = {
    icon: 'dollar-sign',
    img: 'profile-tipbox.svg',
    get label() { return i18n.t('sidebar.activateTipbox') },
    to: { path: '/widgeter/tipbox/activation' },
    get isActive() { return !isTipboxActive() },
};
const widgeterTipboxTips = {
    img: 'payments.svg',
    get label() { return i18n.t('sidebar.tipboxTips') },
    to: { name: 'TipboxTips' },
    get isActive() { return isTipboxActive() },
};
const widgeterTipboxSettlements = {
    img: 'settlements.svg',
    get label() { return i18n.t('sidebar.tipboxSettlements') },
    to: { name: 'TipboxSettlements' },
    get isActive() { return isTipboxActive() },
};
const widgeterTipboxSettings = {
    img: 'widget-tipbox.svg',
    get label() { return i18n.t('sidebar.widgetTipBox') },
    to: { name: 'WidgeterTipboxSettings' },
    get isActive() { return isTipboxActive() },
};
const widgeterTipboxLink = {
    img: 'profile-tipbox.svg',
    get label() { return i18n.t('sidebar.profileTipBox') },
    to: { name: 'WidgeterTipboxLink' },
    get isActive() { return isTipboxActive() },
};
const productGroups = {
    icon: 'shopping-cart',
    get label() { return i18n.t('sidebar.productGroups') },
    to: { name: 'ProductGroups' },
};
const productCatalog = {
    icon: 'shopping-bag',
    get label() { return i18n.t('sidebar.productCatalog') },
    to: { name: 'ProductCatalog' },
};
const competitiveAnalysis = {
    icon: 'trending-up',
    get label() { return i18n.t('sidebar.competitiveAnalysis') },
    to: { name: 'CompetitiveAnalysis' },
};
const plugin = {
    icon: 'globe',
    get label() { return i18n.t('sidebar.widget') },
    to: { name: 'Plugin' },
};
const settingsSpaces = {
    get label() { return i18n.t('sidebar.yourWebsites') },
    to: { name: 'SettingsSpaces' },
};
const settingsSubscriptions = {
    get label() { return i18n.t('sidebar.subscriptions') },
    to: { name: 'SettingsSubscriptions' },
};
const settingsWebhooks = {
    get label() { return i18n.t('sidebar.webhooks') },
    to: { name: 'SettingsWebhooks' },
};
const dataExport = {
    icon: 'database',
    get label() { return i18n.t('sidebar.dataExport') },
    to: { name: 'DataExport' },
};
const reportsShops = {
    get label() { return i18n.t('sidebar.shops') },
    to: { name: 'ReportsShops' },
};
const reportsCategories = {
    get label() { return i18n.t('sidebar.categories') },
    to: { name: 'ReportsCategories' },
};
const reportsProducts = {
    get label() { return i18n.t('sidebar.products') },
    to: { name: 'ReportsProducts' },
};
const reportsAvailability = {
    get label() { return i18n.t('sidebar.availability') },
    to: { name: 'ReportsAvailability' },
};
const reportsPriceDistribution = {
    get label() { return i18n.t('sidebar.priceDistribution') },
    to: { name: 'ReportsPriceDistribution' },
};
const reportsSales = {
    get label() { return i18n.t('sidebar.sales') },
    to: { name: 'ReportsSales' },
};
const importModeration = {
    icon: 'package',
    get label() { return i18n.t('sidebar.importModeration') },
    to: { name: 'ImportModeration' },
};
const offersModeration = {
    icon: 'package',
    get label() { return i18n.t('sidebar.offersModeration') },
    to: { name: 'OffersModeration' },
};
const aggregateModeration = {
    icon: 'package',
    get label() { return i18n.t('sidebar.aggregateModeration') },
    to: { name: 'AggregateModeration' },
};
const producerHelp = {
    icon: 'help-circle',
    get label() { return i18n.t('sidebar.help') },
    href: 'https://100shoppers.com/help-center/',
    target: '_blank',
};
const affiliation = {
    img: 'affiliation-white.svg',
    get label() { return i18n.t('sidebar.affiliation') },
    root: true,
};
const tips = {
    img: 'tips-white.svg',
    get label() { return i18n.t('sidebar.tips') },
    root: true,
};
/* eslint-enable prettier-vue/prettier, semi */

export function findRouteByName(routeName, routes) {
    // eslint-disable-next-line
    for (const route of routes) {
        if (route.name === routeName) {
            return route;
        }
        if (route.children) {
            const foundRoute = findRouteByName(routeName, route.children);
            if (foundRoute) {
                return foundRoute;
            }
        }
    }
    return null;
}

export function getFeatureByRouteName(routeName) {
    try {
        const route = findRouteByName(routeName, routerRoutes);
        return route?.meta?.feature || null;
    } catch (error) {
        return null;
    }
}

export function isRouteEnabled(item) {
    if (!item.to) return true;
    const routeFeatureFlag = getFeatureByRouteName(item.to.name);
    if (!routeFeatureFlag) return true;
    const flag = store.getters['auth/isFeatureFlagEnabled'](routeFeatureFlag);
    return flag;
}

export function getSidebar(sidebar) {
    return sidebar.reduce((acc, sidebarItem) => {
        const item = Array.isArray(sidebarItem) ? sidebarItem[0] : sidebarItem;
        if (!item) return acc;
        const children = Array.isArray(sidebarItem) ? sidebarItem[1] : undefined;
        if (!isRouteEnabled(item)) return acc;
        if (!children?.length) return [...acc, { ...item }];
        const newChildren = getSidebar(children);
        const newItem = { ...item, children: newChildren };
        return [...acc, newItem];
    }, []);
}

export const sidebar = () => {
    /* eslint-disable */

    if (globalData.user.isRoleAdmin) {
        return getSidebar([
            [dashboard],
            [reports, [reportsStats, reportsTransactions, reportsConversion, reportsIntegrationStatus, reportsFeedImportSummary, reportsWidgetVersionChart]],
            [catalog, [aggregateModeration, importModeration, offersModeration, catalogProducts, catalogProductVariants, catalogCategories, catalogBrands, catalogManufacturers]],
            [users],
            [adminTipbox, [adminTipboxTips, adminTipboxVerification, adminTipboxSettlements]],
            [webpagesAdmin, [webpagesListAdmin]],
            [settlements, [settlementsReport, settlementsInvoices]],
            [campaignsAdmin, [campaignsListAdmin]],
            [producerProducts, [producerProductsSearch, producerProductsImport]],
            [offers],
            [products],
            [transactions, [transactionImport, transactionValidation, transactionCorrection]],
            [finance, [financeSubscriptions, adminFinanceSettlementsPublishers]],
        ]);
    }

    if (globalData.user.isRoleWidgeter) {
        return getSidebar([
            [dashboard],
            [affiliation,
                [
                    [textLinks],
                    [widget, [widgetGenerator, widgetSettings]],
                    [productLandingPage, [productLandingPageGenerator, productLandingPageSettings]],
                    [activateWidgeterTipbox],
                    [reports, [reportsStats, reportsTransactions, reportPages, reportShops, reportProducts]],
                    [pages],
                    [shops],
                    [finance],
                    [settings, [settingsApi, settingsIntegrations]],
                ],
            ],
            [tips,
                [activateWidgeterTipbox, widgeterTipboxTips, widgeterTipboxSettlements, widgeterTipboxLink, widgeterTipboxSettings],
            ],
        ]);
    }

    if (globalData.user.isRoleAdvertiser) {
        return getSidebar([
            [dashboard],
            [webpagesPublishers],
            [reports, [reportsStats, reportsTransactions, reportsPages]],
            [settings, [settingsShopPresentation]],
            [api],
            [offersCatalog],
        ]);
    }

    if (globalData.user.isRoleProducer) {
        return getSidebar([
            [dashboard],
            [productGroups],
            [productCatalog],
            [reports, [reportsShops, reportsCategories, reportsProducts, reportsAvailability, reportsPriceDistribution, reportsSales]],
            [competitiveAnalysis],
            [plugin],
            [settings, [settingsSpaces, settingsSubscriptions, settingsWebhooks]],
            [dataExport],
            [producerHelp]
        ]);
    }

    return [];
    /* eslint-enable */
};

export default sidebar;
